<nav class="content-wrapper">
  <div class="header desktop content-mx-width">
    <div class="header__logo">
      <a [routerLink]="['/']">
        <img src="assets/img/everight-logo-small.png" alt="logo" />
      </a>
    </div>
    <!-- <div class="header__navs">
      <ul class="menu">
        <ul *ngIf="token" class="user">
          <p> {{username}} </p>

          <img
            style="cursor: pointer"
            [matMenuTriggerFor]="menu"
            src="/assets/icons/user-circle.svg"
            alt=""
          />
          <mat-menu #menu="matMenu">
            <a
              [routerLink]="['/profile']"
              >
              <button mat-menu-item>
                Account
              </button>
              </a>
              <button *ngIf="role == 'Administrator'" (click)="openUser()" mat-menu-item>
                Users
              </button>
                <a
                [routerLink]="['/login']"
                >
                <button *ngIf="!token" mat-menu-item>
                  Login
                </button>
                </a>
                <a
                [routerLink]="['/password-reset']"
                >
                <button *ngIf="token" mat-menu-item>
                  Change Password
                </button>
                </a>
            <button (click)="logout()" mat-menu-item>
              Logout
            </button>
          </mat-menu>
        </ul>
      </ul>
    </div> -->
  </div>
  <div class="header mobile">
    <div class="header__logo">
      <a [routerLink]="['/']">
        <!-- Everight -->
      </a>
    </div>

    <div class="mobile__navs">
      <input id="toggle" type="checkbox" ngModel #toggle="ngModel" />

      <label class="toggle-container" for="toggle">
        <!-- If menu is open, it will be the "X" icon, otherwise just a clickable area behind the hamburger menu icon -->
        <span class="button button-toggle"></span>
      </label>

      <nav class="nav">
        <a class="nav-item">1</a>
        <a class="nav-item">1</a>
        <a class="nav-item">1</a>
      </nav>
      <!-- -->
    </div>
    <div
      class="mobile-menu-container"
      [@mobileNav]="toggle.value ? 'grow' : 'shrink'"
    >
      <ul class="menu">
        <li>
          <a [routerLink]="['/']">Home </a>
        </li>
        <li>
          <a *ngIf="role == 'Administrator'" (click)="openUser()">Users </a>
        </li>
        <li>
          <a (click)="openPointment()" *ngIf="role == 'self-service user'"
            >Appointments
          </a>
        </li>
        <li>
          <a (click)="bookApointment()" *ngIf="role == 'self-service user'"
            >Book Appointments
          </a>
        </li>

        <li>
          <a
            [routerLink]="['/online-finalise']"
            *ngIf="role == 'self-service consultant'"
            >Result Finalize</a
          >
        </li>
        <li>
          <a
            [routerLink]="['/online-view-result']"
            *ngIf="role == 'self-service user'"
            >View Result</a
          >
        </li>
      </ul>
    </div>
  </div>
</nav>
